import './App.css';
import Card from "./Card";
import {useState} from "react";

function App() {
    const [name, setName] = useState("Ystös");
    const [illustration, setIllustration] = useState(null);
    const [description, setDescription] = useState("La plupart des joueurs ne prennent pas le temps de peaufiner les détails, mais les détails, c'est ce qui fait toute la différence entre un bon niveau et l'élite")

    return (
        <div className="flex w-screen h-screen bg-slate-500 p-4 gap-4">
            <div className="grow-1 flex flex-col gap-2">
                <label for="name">Nom</label>
                <input id="name" className="block bg-white w-full p-2 rounded" type="text" value={name} onChange={e => setName(e.target.value)} />
                <label for="description">Description</label>
                <textarea id="description" className="block w-full bg-white p-2 rounded min-h-42" value={description} onChange={e => setDescription(e.target.value)} />
                <label for="illustration">Illustration</label>
                <input className="cursor-pointer bg-blue-500 p-2 rounded" id="illustration" type="file" onChange={e => setIllustration(e.target.files[0])} />
            </div>
            <Card illustration={illustration} name={name} description={description} />
        </div>
    );
}

export default App;
